import { i18n } from '../translate'

export const translateError = e => {
  const errors = {
    "Email address is already in use.": "Sie haben ein ForMe -Konto mit dieser E-Mail registriert. Bitte gehen Sie zur Anmeldeseite.",
    "IBAN already used": "IBAN bereits verwendet",
    "IBAN is alreaedy in use": "Die soeben angegebene IBAN hat im Rahmen unserer Aktion bereits erfolgreich teilgenommen. Bitte verwenden Sie eine andere IBAN!",
    "Incorrect username or password. Please try again.": "Falscher Benutzername oder falsches Passwort. Bitte versuche es erneut."
  }
  return errors[e]
}
export default {
  methods: {
    goToPage: (pageName, self) => {
      // console.log("gotopage::->", pageName)
      self.$eventHub.$emit('goToPage-event', pageName);

      // change url when moving to another page
      if (location.pathname.split('/').join('') !== pageName) {
        history.replaceState({}, null, '/' + localStorage.getItem('lang') + '/' + pageName)
      }
    },
    goToPageWithData: (pageName , self) => {
      console.log(pageName , self)
    },
    sendProductPhotos: (params, buttonComponent) => {
      let fieldId = params;
      // console.log("1. will SEND products:::", fieldId, buttonComponent)

      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));

      buttonComponent.$eventHub.$emit('sendProductPhotos-event', fieldId);
    },
    sendForm: (params, buttonComponent) => {
      if (params.indexOf(',') > -1) {
        params = params.split(',')
      }
      let formId = params;
      let neuStarTrigger = false
      if (self._.isArray(params)) {
        formId = params[0]
        neuStarTrigger = params.filter(param => param === 'neuStarTrigger')
        // console.log("1. will SEND FORM:::", formId, 'neuStarTrigger', neuStarTrigger.length > 0)
      }
      const triggers = {
        neuStarTrigger: neuStarTrigger.length > 0
      }
      // console.log("1. will SEND FORM:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      // console.log("2. will SEND FORM:::", formId, buttonComponent)

      buttonComponent.$eventHub.$emit('getFormData-event', formId, triggers);
    },
    sendSms: (component, buttonComponent) => {
      // console.log("1. will SEND SMS:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('sendSms-event');
    },
    verifySms: (component, buttonComponent) => {
      // console.log("1. will SEND SMS:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('verifySms-event');
    },
    sendSurvey: (component, buttonComponent) => {
      // console.log("1. will SEND SMS:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('getSurveyData-event');
    },
    sendProducts: (formId, buttonComponent) => {
      // console.log("SEND PRODUCTS:::", formId)
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('sendProducts-event', formId);
    },
    printForm: (formId, buttonComponent) => {
      // console.log("SEND PRODUCTS:::", formId)
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.$emit('printForm-event', formId);
    },
    getCustomerToken: (params, self) => {
      // console.log("getCustomerToken", self)
      self.$store.dispatch('retrieveUserToken')
    },
    doneTrigger: (component, eventResult) => {
      component.$eventHub.$off('done-event-trigger');
      component.loading = false
      if (!eventResult.status && eventResult.message) {
        component.$store.dispatch('handleError', eventResult)
      }

    },
    sendReceipt: (component, buttonComponent) => {
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$emit('sendReceipt-event')
    },
    sendEmail: (data, buttonComponent) => {
      buttonComponent.loading = true;
      buttonComponent.$eventHub.$on('email-sent-trigger',
        (parent) => buttonComponent.emailSentTrigger(buttonComponent, parent));

      buttonComponent.$eventHub.$emit('sendmail-event', data);
    },
    emailSentTrigger: (component, eventResult) => {
      component.$eventHub.$off('email-sent-trigger');
      component.loading = false

      // Email was sent
      if (eventResult.success) {
        component.showModal(eventResult.message, 'success')
        eventResult.parent.clear()

        // Clear The product state
        component.$store.commit('resetProducts');
        component.$store.commit('setProductCode', '');
        component.$store.commit('setSearchStatus', null);

        // Move back to home page
        component.goToPage('startseite', component)
      }
      if (!eventResult.status && eventResult.message) component.showModal(eventResult.message)


    },
    isMobileOrTablet ( currentScreenSize ) {
      return currentScreenSize < 992 ? true : false
    },
    displaySuccess () {
      this.$eventHub.$emit('display-success');
    },
    receiptUploaderToProductUploader ( _ , self) {

      const sp = self.$store.getters.scannedProducts;
      // console.log()

      if (sp.every(item => item.isFeRequired === 0)) {
        self.goToPage('produktfoto-hochladen-bs', self)
      } else {
        self.goToPage('produktfoto-hochladen-fs', self)
      }
    }
  }
}
